import { render, staticRenderFns } from "./AppliedDetail.vue?vue&type=template&id=28a13b3b"
import script from "./AppliedDetail.vue?vue&type=script&lang=js"
export * from "./AppliedDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports